module.exports = __webpack_public_path__ + "static/media/f37ginger-light-webfont.2551d8cc.woff2";